var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-accident-documentation loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-accident-documentation-basedata", {
                            attrs: {
                              "form-context":
                                _vm.initialFormContexts
                                  .accidentDocumentationBasedata,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }